<template>
    <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing lead-info-box rounded-0">
        <div class="card-head box-shadow bg-white p-15 p-sm-20 p-md-25 gap-3 d-flex justify-content-between flex-wrap">
            <div class="d-sm-flex align-items-center justify-content-between">
                <h5 class="fw-medium text-black-emphasis mb-0">{{ $t('feature.roles.center_users_management') }}</h5>
            </div>
            <SpinnerLoading v-if="roles === undefined || permissions === undefined" />
            <div class="d-inline-flex flex-wrap gap-3 justify-content-end ms-auto" v-else>
                <button v-for="role in activeRoles" :key="role.id" @click="createUser(role)"
                    class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block text-decoration-none">
                    {{ $t('cta.create') }} {{ role.name }}
                    <i class="ph-bold ph-plus position-relative ms-5 fs-12"></i>
                </button>
            </div>
        </div>
        <div class="card-body p-15 p-sm-20 p-md-25">
            <CenterHCPList :center_id="id" @delete="update" />
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue';
import API from "@/services/api/api.service";
import { RoleWithCenterPermissions, RolePermission } from '@/utils/models/user.model';
import SpinnerLoading from '@/components/Widgets/Spinner.vue';
import { PERMISSION_ACTIONS } from '@/utils/const/permission_actions';
import CenterHCPList from "@/components/FK/Center/CenterHCPList.vue";

export default defineComponent({
    name: "CenterCreateRoles",
    data() {
        return {
            permissions: undefined as RolePermission[] | undefined,
            roles: undefined as RoleWithCenterPermissions[] | undefined,
            actions: PERMISSION_ACTIONS
        }
    },
    emits: ['update'],
    props: {
        id: {
            type: [String, Number],
            required: true
        }
    },
    methods: {
        loadPermissions() {
            API.getCenterPermissions(this.$props.id).then((response) => {
                this.permissions = response?.data?.data ?? [];
                API.getRoles({ ids: this.permissions?.map((permission) => permission.role_id).join(',') }).then((res) => {
                    this.roles = res?.data?.data ?? [];
                    this.roles?.forEach((role) => {
                        let permission = this.permissions?.find((el) => el.role_id === role.id);
                        role.center_permissions = permission ?? {
                            center_id: this.id,
                            role_id: role.id,
                            index: false,
                            show: false,
                            destroy: false,
                            update: false,
                            store: false,
                        } as RolePermission;
                    });
                })
            });
        },
        updateRolePermission(role: RoleWithCenterPermissions, action: string) {
            API.updateRolePermissions(role.center_permissions).then((response) => {
                if (response.data.success === false) {
                    role.center_permissions[action] = !role.center_permissions[action];
                }
            }).catch((error) => {
                role.center_permissions[action] = !role.center_permissions[action];
            });
        },
        createUser(role: RoleWithCenterPermissions) {
            this.$router.push({
                path: '/create-user', query: {
                    center_id: this.id,
                    role_id: role.id,
                    role_name: role.name
                },
            })
        },
        update() {
            this.$emit('update');
        }
    },
    mounted() {
        this.loadPermissions();
    },
    computed: {
        activeRoles() {
            return this.roles?.filter((role) => {
                let permission = role.center_permissions;
                return permission.index == true || permission.show == true || permission.store == true || permission.update == true || permission.destroy == true;
            })
        }
    },
    components: {
        SpinnerLoading,
        CenterHCPList
    }
});
</script>